import syncOperators from "./images/sterilis/sync_customer_operators.png";
import softLabBioValidation from "./images/sterilis/soft_lab_waste_bio_validation.png";
import goodDrainGoodVacuum from "./images/sterilis/good_drain_good_vacuum.png";


export const changelog = [
    {
        type: "new",
        audience: "customer",
        desc: "Added Instant Error Reporting.",
        details:
            "As soon as an error occurs on a remediator, customers with their notification setting set to include Error notifications will receive an email describing the error. Completion and completion with error emails will be sent to customers with “Completion” notifications, and the new Error emails will be sent to customers with “Error” notifications. Both will be sent if “Completion and Error” is selected.",
        images: [],
    },
    {
        type: "chg",
        audience: "customer",
        desc: "Various Bug Fixes and Improvements",
        details: "Improved performance and fixed several minor bugs.",
        images: [],
    },
    {
        type: "chg",
        audience: "sterilis",
        desc: "Added Read Replica to the Database",
        details:
            "Added a read replica to the database to improve performance and reduce the load on the primary database.",
        images: [],
    },
    {
        type: "new",
        audience: "sterilis",
        desc: "Allow Distributor FSEs to Edit Facilities.",
        details:
            "Distributor Field Service Engineers can now edit Facilities. This will allow them to update the Facility’s information, such as the Facility’s name, address, and contact information.",
        images: [],
    },
    {
        type: "new",
        audience: "sterilis",
        desc: "Add Inspect Bottom Lid Cycle",
        details:
            "* Currently only in unreleased Bullseye Versions, not in 3.4.1.1 Buster Release *",
        images: [],
    },
    {
        type: "new",
        audience: "sterilis",
        desc: "Removed Non-Functional Create a Machine Button From Distributor Users.",
        details:
            "Distributor users can no longer see the Create a Machine menu option. This option was not functional and was removed.",
        images: [],
    },
    {
        type: "new",
        audience: "sterilis",
        desc: "Added Good Drain and Good Vacuum Options",
        details:
            "* Currently only in unreleased Bullseye Versions, not possible in buster because it is built into the custom waste menu *",
        images: [{ id: "sync-customer-operators", src: goodDrainGoodVacuum, title: "Sync Customer Operators" }],
    },
    {
        type: "new",
        audience: "sterilis",
        desc: "Added Sync Customer Operator Button.",
        details:
            "Added a Sync Customer Operator button * Currently only available to Super Users *",
        images: [{ id: "good-drain-good-vacuum", src: syncOperators, title: "Good Drain Good Vacuum" }],
    },
    {
        type: "new",
        audience: "sterilis",
        desc: "Added Soft Lab Waste Bio Validation.",
        details:
            "Added a Soft Lab Wast Bio Validation button. Located in the device configuration settings.",
        images: [{ id: "soft-lab-bio-validation", src: softLabBioValidation, title: "Soft Lab Waste Bio-Validation" }],
    },
    {
        type: "fix",
        audience: "sterilis",
        desc: "Fixed Tr Avg Ramp in BIT-7.",
        details:
            "Fixed calculations for the Tr Avg Ramp in BIT-7 to not include metrics from the build pressure and pumpdown state.",
        images: [],
    },
    {
        type: "fix",
        audience: "sterilis",
        desc: "Fixed Duplicate Terms and Conditions Prompts.",
        details:
            "Fixed issue with new users being required to accept the terms and conditions multiple times.",
        images: [],
    },
    {
        type: "fix",
        audience: "sterilis",
        desc: "Fixed Issue with Cycle Metrics.",
        details:
            "Fixed issue in the testbed environments where cycle metrics were showing error page when navigating from device dashbaoard.",
        images: [],
    },

];
